import { createContext, useCallback, useContext, useEffect, useState } from "react";

const STORAGE_KEY = "app_lang";

const STRINGS = {
    ar: {
        dir: "rtl",
        // ── Branding / shared ────────────────────────────────
        brand: "معيار",
        brandTag: "Al Meyar • نظام محاسبة الذهب",
        brandSubtitle: "إدارة دفاتر حسابات العملاء بدقّة احترافية.",

        // ── Auth: Login / Register ──────────────────────────
        loginAppTagline: "نظام محاسبة الذهب",
        loginTitle: "تسجيل الدخول",
        loginSubtitle: "أدخل بيانات الشركة للوصول إلى دفتر الحسابات.",
        companyLabel: "اسم الشركة",
        companyPlaceholder: "شركة الذهب الأنيق",
        passwordLabel: "كلمة المرور",
        passwordPlaceholder: "••••••••",
        loginSubmit: "تسجيل الدخول",
        loginSubmitLoading: "جاري الدخول...",
        loginNoAccount: "ليس لديك حساب؟",
        loginGoRegister: "إنشاء حساب جديد",
        registerAppTagline: "إنشاء حساب شركة جديدة",
        registerTitle: "حساب جديد",
        registerSubtitle: "سجّل اسم الشركة وكلمة المرور لتبدأ.",
        confirmPasswordLabel: "تأكيد كلمة المرور",
        registerSubmit: "إنشاء الحساب",
        registerSubmitLoading: "جاري الإنشاء...",
        registerHaveAccount: "لديك حساب؟",
        registerGoLogin: "تسجيل الدخول",
        passwordMismatch: "كلمتا المرور غير متطابقتين",
        toggleAria: "تغيير اللغة",
        toggleNext: "EN",

        // ── Phone / Location ────────────────────────────────
        phoneLabel: "رقم الهاتف",
        phonePlaceholder: "+96891234567",
        phoneInvalid: "رقم الهاتف غير صالح",
        phoneRequired: "رقم الهاتف مطلوب",
        countryLabel: "الدولة",
        cityLabel: "المدينة",
        countryPlaceholder: "اختر الدولة...",
        cityPlaceholder: "اختر المدينة...",
        searchCountry: "ابحث عن دولة...",
        searchCity: "ابحث عن مدينة...",
        locationLabel: "الموقع (الدولة - المدينة)",
        locationLocked: "تم القفل — لا يمكن التعديل",
        phoneLocked: "تم القفل — لا يمكن التعديل",
        savePhone: "حفظ رقم الهاتف",
        saveLocation: "حفظ الموقع",
        phoneSetTitle: "أكمل بيانات الحساب — رقم الهاتف",
        phoneSetHint: "أضف رقم الهاتف لاستخدامه عند نسيان كلمة المرور. يُحفظ مرّة واحدة ولا يمكن تعديله لاحقاً.",
        locationSetTitle: "أكمل بيانات الحساب — الموقع",
        locationSetHint: "اختر الدولة ثم المدينة. يُحفظ مرّة واحدة ولا يمكن تعديله لاحقاً.",
        phoneSavedToast: "تم حفظ رقم الهاتف.",
        phoneEditOnceHint: "يمكنك تعديل رقم الهاتف مرّة واحدة فقط، وبعدها سيتم قفله نهائياً.",
        phoneCurrent: "الرقم الحالي",
        locationSavedToast: "تم حفظ الموقع.",

        // ── Forgot password ─────────────────────────────────
        forgotLink: "نسيت كلمة المرور؟",
        forgotTitle: "استعادة كلمة المرور",
        forgotPhoneStep: "أدخل اسم الحساب ورقم الهاتف",
        forgotPhoneHint: "تأكّد من المطابقة، سنرسل رمز تحقّق إلى رقم الهاتف.",
        forgotSendOtp: "إرسال الرمز",
        forgotOtpStep: "أدخل رمز التحقّق",
        forgotOtpHint: "تحقّق من رسالة SMS وأدخل الرمز المكوّن من 6 أرقام.",
        forgotOtpLabel: "رمز التحقّق",
        forgotVerify: "تحقّق",
        forgotResend: "إعادة الإرسال",
        forgotResendIn: "إعادة الإرسال خلال {s} ثانية",
        forgotResetStep: "اختر كلمة مرور جديدة",
        forgotResetHint: "أدخل كلمة المرور الجديدة وأكّدها.",
        forgotResetSubmit: "حفظ كلمة المرور الجديدة",
        forgotBackToLogin: "العودة لتسجيل الدخول",
        forgotDoneToast: "تم تحديث كلمة المرور. سجّل الدخول بكلمتك الجديدة.",
        forgotDevOtpHint: "وضع تطوير: الرمز هو {otp}",

        // ── App Shell (nav) ─────────────────────────────────
        navLedger: "الدفاتر",
        navHistory: "السجلات",
        navSettings: "الإعدادات",
        navLogout: "خروج",

        // ── Ledger picker (home) ────────────────────────────
        pickerLedgersKicker: "الدفاتر",
        pickerLedgersTitle: "اختر دفتراً",
        pickerLedgersSubtitle: "افتح دفتر العملاء أو المصانع أو السجل اليومي.",
        pickerRecordsKicker: "الأرشيف",
        pickerRecordsTitle: "السجلات",
        pickerRecordsSubtitle: "اعرض سجلات العملاء أو المصانع أو السجلات اليومية.",
        clientLedgerTitle: "دفتر العملاء",
        clientLedgerSubtitle: "حسابات العملاء (ذهب فقط).",
        factoryLedgerTitle: "دفتر المصانع",
        factoryLedgerSubtitle: "حسابات المصانع (ذهب + أجور).",
        dailyLedgerTitle: "السجل اليومي",
        dailyLedgerSubtitle: "حركة صندوق النقد اليومية (مبيعات / مصروفات / مشتريات).",
        clientRecordsTitle: "سجلات العملاء",
        clientRecordsSubtitle: "السجلات المحفوظة من دفتر العملاء.",
        factoryRecordsTitle: "سجلات المصانع",
        factoryRecordsSubtitle: "السجلات المحفوظة من دفتر المصانع.",
        dailyRecordsTitle: "السجلات اليومية",
        dailyRecordsSubtitle: "السجلات اليومية المحفوظة (للقراءة فقط).",
        backToPicker: "الدفاتر",
        backToRecordsPicker: "السجلات",

        // ── Ledger page ─────────────────────────────────────
        ledgerKicker: "دفتر الحسابات",
        ledgerTitle: "صفحة جديدة",
        ledgerSubtitle:
            'أدخل اسم العميل وأضف القيود، ثم اضغط "حفظ" لإضافة السجل إلى الأرشيف. يمكنك فتحه وتعديله لاحقاً.',
        ledgerEmpty: "صفحة فارغة",
        ledgerSaveBtn: "حفظ السجل",
        clientNameLabel: "اسم العميل",
        clientNamePlaceholder: "اكتب اسم العميل...",
        pageDate: "تاريخ الصفحة",
        creditTitle: "له العميل",
        debitTitle: "عليه العميل",
        goldChip: "GOLD — الذهب",
        cashChip: "CASH — النقد",
        netGoldLabel: "صافي الذهب (له − عليه)",
        netFeesLabel: "صافي الأجور (له − عليه)",
        forLabel: "له:",
        againstLabel: "عليه:",
        toastNeedClient: "الرجاء إدخال اسم العميل قبل الحفظ.",
        toastEmptyLedger: "الدفتر فارغ، أضف صفاً واحداً على الأقل.",
        toastSaved: "تم حفظ السجل في الأرشيف.",
        toastSaveFail: "تعذّر الحفظ.",

        // ── LedgerTable ─────────────────────────────────────
        colKaratType: "نوع العيار",
        colWeight: "الوزن",
        colKarat: "العيار",
        colResult: "الناتج",
        colManufacturing: "المصنوعية",
        colDescription: "البيان",
        colInvoice: "رقم الفاتورة",
        colFees: "الأجور",
        colGoldReceived: "مستلم الذهب",
        colDate: "التاريخ",
        rowsOne: "صف",
        rowsMany: "صفوف",
        addRow: "إضافة صف",
        deleteRow: "حذف الصف",
        emptyTable: 'لا توجد قيود بعد. اضغط "إضافة صف" للبدء.',
        totalFees: "إجمالي الأجور",
        rowWord: "صف",
        cellWord: "خلية",
        navUp: "أعلى",
        navDown: "أسفل",
        navPrev: "السابق",
        navNext: "التالي",

        // ── History ─────────────────────────────────────────
        historyKicker: "الأرشيف",
        historyTitle: "السجلات المحفوظة",
        historySubtitle: "ابحث عن صفحات سابقة باسم العميل.",
        historySearchPlaceholder: "ابحث باسم العميل...",
        historyEmptyTitle: "لا توجد سجلات",
        historyEmptyHint: "رحّل صفحة من الدفتر لتظهر هنا.",
        deleteWord: "حذف",

        // ── HistoryDetail ───────────────────────────────────
        backToHistory: "السجلات",
        editKicker: "تعديل سجل",
        editFallbackTitle: "سجل",
        createdLabel: "أنشئ:",
        updatedLabel: "آخر تعديل:",
        saveChanges: "حفظ التعديلات",
        toastNeedClientEdit: "الرجاء إدخال اسم العميل.",
        toastEmptyEdit: "السجل فارغ، أضف صفاً واحداً على الأقل.",
        toastEditSaved: "تم حفظ التعديلات.",
        toastEditFail: "تعذّر حفظ التعديلات.",
        netGoldShort: "صافي الذهب",
        netFeesShort: "صافي الأجور",

        // ── Settings ────────────────────────────────────────
        backToLedger: "الدفتر",
        settingsKicker: "الإعدادات",
        settingsTitle: "الإعدادات",
        settingsSubtitle: "إدارة حساب الشركة",
        accountSecurity: "حماية الحساب",
        accountSecurityHint: "غيّر كلمة المرور بانتظام للحفاظ على أمان دفتر الحسابات.",
        secTip1: "استخدم 8 أحرف أو أكثر",
        secTip2: "امزج بين الأحرف والأرقام",
        secTip3: "لا تشاركها مع أي شخص",
        changePassword: "تغيير كلمة المرور",
        changePasswordHint: "أدخل كلمة المرور الحالية ثم الجديدة. سيتم تسجيل خروجك بعد التغيير.",
        currentPassword: "كلمة المرور الحالية",
        newPassword: "كلمة المرور الجديدة",
        confirmNewPassword: "تأكيد كلمة المرور الجديدة",
        clearBtn: "مسح",
        saveNewPassword: "حفظ كلمة المرور الجديدة",
        passwordChangedToast:
            "تم تغيير كلمة المرور بنجاح. يُرجى تسجيل الدخول مرة أخرى.",
        allFieldsRequired: "جميع الحقول مطلوبة",
        newPasswordTooShort: "كلمة المرور الجديدة قصيرة جداً (4 أحرف على الأقل)",
        passwordsDontMatch: "كلمتا المرور غير متطابقتين",
        newPasswordSameAsCurrent: "كلمة المرور الجديدة مطابقة للحالية",
        changePasswordFail: "تعذّر تغيير كلمة المرور",

        deletionCodeTitle: "رمز الحذف",
        deletionCodeHint:
            "رمز خاص يُطلب قبل حذف أي سجل من الأرشيف. الافتراضي هو كلمة المرور — يُنصح بتغييره إلى رمز مختلف.",
        newDeletionCode: "رمز الحذف الجديد",
        confirmDeletionCode: "تأكيد الرمز",
        saveDeletionCode: "حفظ رمز الحذف",
        deletionCodeShort: "رمز الحذف قصير جداً (4 أحرف على الأقل)",
        codesDontMatch: "الرمزان غير متطابقان",
        currentPasswordWrong: "كلمة المرور الحالية غير صحيحة",
        deletionCodeUpdated: "تم تحديث رمز الحذف.",
        deletionCodeUpdateFail: "تعذّر تحديث رمز الحذف",

        dangerZoneTitle: "منطقة خطرة — حذف الحساب",
        dangerZoneHint1:
            "سيتم حذف حساب الشركة وجميع السجلات المحفوظة نهائياً ولا يمكن استرجاعها.",
        dangerZoneHint2: "سيصبح اسم الشركة",
        dangerZoneHint3: "متاحاً للاستخدام مرة أخرى.",
        deleteAccount: "حذف الحساب",
        deleteAccountConfirmTitle: "تأكيد حذف الحساب",
        irreversible: "لا يمكن التراجع عنه",
        actionWillDelete: "هذا الإجراء",
        sectorsDeleted: "سيتم حذف:",
        bullet1: "حساب الشركة وكلمة المرور",
        bullet2: "جميع السجلات والصفحات المحفوظة",
        enterPasswordToConfirm: "أدخل كلمة المرور للتأكيد:",
        cancel: "إلغاء",
        deleteForever: "نعم، احذف نهائياً",
        accountDeletedToast: "تم حذف الحساب. يمكن استخدام اسم الشركة من جديد.",
        accountDeleteFail: "تعذّر حذف الحساب",
        passwordRequired: "الرجاء إدخال كلمة المرور للتأكيد",

        // ── Logout confirmation ─────────────────────────────
        logoutConfirmTitle: "تأكيد تسجيل الخروج",
        logoutConfirmBody: "هل أنت متأكد من رغبتك في تسجيل الخروج من الحساب؟",
        logoutConfirmOk: "نعم، سجّل الخروج",

        // ── Preferences (language + theme) ──────────────────
        preferencesTitle: "التفضيلات",
        preferencesHint: "اختر لغة العرض ومظهر التطبيق (فاتح/داكن).",
        languageLabel: "لغة العرض",
        themeLabel: "مظهر التطبيق",
        themeLight: "فاتح",
        themeDark: "داكن",

        // ── Delete-account OTP step ─────────────────────────
        deleteAccountOtpIntro: "لحذف الحساب نهائياً، سنرسل رمز تحقّق إلى رقم الهاتف المسجّل.",
        deleteAccountOtpStep: "أدخل رمز التحقّق المرسل إلى",
        deleteAccountSendOtp: "إرسال رمز التحقّق",
        deleteAccountConfirmFinal: "تأكيد الحذف",

        // ── Invoices (owner-only) ───────────────────────────
        invoicesNavBtn: "الفواتير",
        invoicesTitle: "سجل الفواتير",
        invoicesSubtitle: "جميع فواتير الاشتراكات والتجديدات. للحذف يلزم تأكيد كلمة مرور المالك.",
        invoicesKicker: "لوحة المالك",
        invoicesEmpty: "لا توجد فواتير بعد",
        invoicesEmptyHint: "ستظهر الفواتير هنا تلقائياً مع كل اشتراك أو تجديد.",
        invoicesSearchPlaceholder: "ابحث باسم الشركة...",
        invoicesFilterAll: "الكل",
        invoicesFilterNew: "اشتراك جديد",
        invoicesFilterRenewal: "تجديد",
        invoicesActionNew: "جديد",
        invoicesActionRenewal: "تجديد",
        invoicesSortBy: "ترتيب حسب",
        invoicesSortDate: "التاريخ",
        invoicesSortCompany: "الشركة",
        invoicesSortPrice: "السعر",
        invoicesSortDirAsc: "تصاعدي",
        invoicesSortDirDesc: "تنازلي",
        invoicesColNumber: "رقم الفاتورة",
        invoicesColCompany: "الشركة",
        invoicesColPhone: "الهاتف",
        invoicesColDate: "التاريخ",
        invoicesColAction: "النوع",
        invoicesColPlan: "الخطة",
        invoicesColPrice: "السعر",
        invoicesColActions: "إجراءات",
        invoicesDeleteBtn: "حذف",
        invoicesCountChip: "فاتورة",
        invoicesTotalRevenue: "إجمالي الإيرادات",
        invoicesDeleteConfirmTitle: "حذف الفاتورة",
        invoicesDeleteConfirmBody: "هل أنت متأكد من حذف هذه الفاتورة؟ لا يمكن التراجع عن هذا الإجراء.",
        invoicesDeleteOwnerPwLabel: "أعد إدخال كلمة مرور المالك للتأكيد",
        invoicesDeleteConfirmOk: "تأكيد الحذف",
        invoicesDeletedToast: "تم حذف الفاتورة.",
        invoicesPlanMonthly: "شهري",
        invoicesPlanYearly: "سنوي",
        // Company subscription stat chips (in AdminAccounts cards)
        statsTotalSubs: "إجمالي الاشتراكات",
        statsNewSubs: "جديد",
        statsRenewalSubs: "تجديد",

        // ── Delete Ledger Dialog ────────────────────────────
        deleteEnterCode: "أدخل رمز الحذف للمتابعة",
        deleteEnterCodeHint:
            "لحماية بياناتك، يجب إدخال رمز الحذف الخاص بالشركة قبل حذف أي سجل.",
        deletionCodeFieldLabel: "رمز الحذف",
        nextBtn: "التالي",
        defaultDeletionCodeNote:
            "رمز الحذف الافتراضي هو كلمة المرور. يمكنك تغييره من الإعدادات.",
        enterCodePlease: "الرجاء إدخال رمز الحذف",
        confirmDeleteTitle: "هل تريد حذف هذه البيانات؟",
        confirmDeleteHint:
            "سيتم حذف السجل بشكل آمن. يمكن استعادته لاحقاً من قِبل المسؤول إذا لزم الأمر.",
        recordLabel: "السجل:",
        no: "لا",
        yesDelete: "نعم، احذف",
        deletedToast: "تم حذف البيانات",
        deleteFail: "تعذّر الحذف",

        // ── DirtyContext dialog ─────────────────────────────
        saveDataTitle: "هل تريد حفظ هذه البيانات؟",
        saveEditsTitle: "هل تريد حفظ التعديلات؟",
        unsavedHint:
            'لديك بيانات غير محفوظة. اختر "نعم" لحفظها قبل المتابعة، أو "لا" للمتابعة دون حفظ.',
        yes: "نعم",

        // ── Admin Accounts ──────────────────────────────────
        ownerPanelKicker: "لوحة المالك",
        accountsLogTitle: "سجل الحسابات",
        accountsLogSubtitle:
            "قائمة بجميع الشركات المسجّلة في الموقع وتاريخ انضمامها. يمكنك حذف أي حساب — سيتم حذف الحساب وكلّ سجلاته نهائياً.",
        searchCompanyPlaceholder: "ابحث باسم الشركة...",
        companiesWord: "شركة",
        noMatchingAccounts: "لا توجد حسابات مطابقة",
        noMatchingHint: "جرّب اسماً آخر، أو امسح حقل البحث لعرض كل الحسابات.",
        joinedAt: "انضمّ:",
        phoneLine: "الهاتف:",
        emailLine: "البريد:",
        locationLine: "الموقع:",
        createdAtLine: "أنشئ في:",
        notSet: "—",
        adminDeleteWillDelete1: "حساب الشركة",
        adminDeleteWillDelete2: "جميع السجلات والصفحات المحفوظة لهذا الحساب",
        adminDeleteCompanyFreed: "سيصبح اسم الشركة متاحاً للاستخدام مرة أخرى.",
        adminAccountDeletedToast: "تم حذف الحساب",
        adminAccountDeleteFail: "تعذّر حذف الحساب",

        // ── Daily Movement Ledger (kind="daily") ────────────
        dailyKicker: "حركة صندوق النقد",
        dailyPageTitle: "سجل يومي",
        dailyDateLabel: "التاريخ:",
        dailySalesTitle: "المبيعات",
        dailyExpensesTitle: "المصروفات",
        dailyPurchasesTitle: "المشتريات",
        dailyColIdx: "م",
        dailyColDesc: "البيانات",
        dailyColGram: "جرام",
        dailyColCash: "كاش",
        dailyColTransfer: "تحويل",
        dailyColBank: "البنك",
        dailyColWeight: "وزن",
        dailyExportLabel: "التصدير",
        dailyTotalLabel: "المجموع",
        dailySpendingLabel: "الصرف",
        dailyBalanceLabel: "الرصيد",
        dailyCalculateBtn: "جمع",
        dailySaveBtn: "حفظ السجل اليومي",
        dailySavedToast: "تم حفظ السجل اليومي.",
        dailySaveFail: "تعذّر حفظ السجل",
        dailyReadOnlyBadge: "للقراءة فقط",
        dailyReadOnlyNote: "السجلات اليومية للقراءة فقط ولا يمكن تعديلها بعد الحفظ.",
        dailyCarriedFromYesterday: "تم نقل أرصدة اليوم السابق تلقائياً",
        dailyNoPrior: "لا يوجد سجل يومي سابق — يبدأ اليوم من الصفر.",
        dailyDateRequired: "التاريخ مطلوب",
        dailyEmpty: "أدخل قيداً واحداً على الأقل قبل الحفظ.",
        dailyConfirmSave: "اختر طريقة الحفظ:",

        // ── Two-stage save (#91): Final / Editable / Ignore / Cancel ──
        saveDialogTitle: "حفظ السجل",
        saveDialogSubtitle: "اختر طريقة الحفظ المناسبة:",
        saveOptionFinal: "حفظ تام",
        saveOptionFinalHint: "إغلاق السجل نهائياً — لا يمكن تعديله بعد ذلك.",
        saveOptionEditable: "حفظ قابل للتعديل",
        saveOptionEditableHint: "حفظ كمسودة قابلة للتعديل لاحقاً.",
        saveOptionIgnore: "تجاهل",
        saveOptionIgnoreHint: "تجاهل التغييرات والرجوع دون حفظ.",
        // Status chips in History
        statusFinalChip: "مغلق نهائياً",
        statusEditableChip: "قابل للتعديل",
        // Edit button in HistoryDetail
        editRecordBtn: "تعديل السجل",
        ledgerSavedEditable: "تم الحفظ كمسودة قابلة للتعديل.",

        // ── Ledger mode selection (full / basic) ────────────
        ledgerModeLabel: "وضع الدفاتر",
        ledgerModeFull: "العملاء + المصانع + السجل اليومي",
        ledgerModeBasic: "العملاء + المصانع فقط",
        ledgerModeHint: "اختر الدفاتر التي ستستخدمها — يُحفظ مرّة واحدة فقط ولا يمكن تعديله لاحقاً.",
        ledgerModeRequired: "الرجاء اختيار وضع الدفاتر",
        ledgerModeSaved: "تم حفظ وضع الدفاتر.",
        ledgerModeLocked: "وضع الدفاتر مقفل — لا يمكن التعديل",
        ledgerModeSettingsHint: "اختر الدفاتر التي تريد تفعيلها — يُحفظ مرّة واحدة فقط.",
        saveLedgerMode: "حفظ وضع الدفاتر",
        dailyDisabledForAccount: "السجل اليومي غير مفعّل لهذا الحساب",

        // ── Daily-variant picker (standard vs advanced) ─────
        dvKicker: "اختر نوع السجل اليومي",
        dvTitle: "السجل اليومي العادي أو دفتر التجارة المتقدم",
        dvSubtitle: "الاختيار لمرّة واحدة فقط ولا يمكن تعديله بعد الحفظ.",
        dvStandardTitle: "السجل اليومي العادي",
        dvStandardDesc: "سجلّ تقليدي لتتبّع المبيعات والمصروفات والمشتريات.",
        dvStandardBullet1: "أقسام: مبيعات، مصروفات، مشتريات",
        dvStandardBullet2: "ترحيل تلقائي لأرصدة اليوم السابق",
        dvStandardBullet3: "حساب الرصيد بسرعة في نهاية اليوم",
        dvAdvancedTitle: "دفتر التجارة المتقدم",
        dvAdvancedDesc: "دفتر تجاري متقدّم لحساب المكسب والرصيد وتفاصيل عمليات الذهب.",
        dvAdvancedBullet1: "حساب المكسب لكل صفقة بيع",
        dvAdvancedBullet2: "إدخال سعر الذهب والمصنعية ووزن الكسر",
        dvAdvancedBullet3: "زر «احسب» لتوليد الإجماليات والرصيد تلقائياً",
        dvSelect: "اختر هذا الدفتر",
        dvSelectedBadge: "النوع المختار",
        dvLockedHint: "النوع مقفل — لا يمكن التعديل",
        dvSaveBtn: "تأكيد الاختيار",
        dvConfirmTitle: "تأكيد نوع الدفتر اليومي",
        dvConfirmBody: "هل أنت متأكد؟ لا يمكن تغيير نوع الدفتر اليومي بعد الحفظ.",
        dvSavedToast: "تم حفظ نوع الدفتر اليومي.",
        dvSaveFail: "تعذّر حفظ الاختيار",
        dvRequired: "الرجاء اختيار نوع الدفتر للمتابعة",
        dvPreviewAlt: "معاينة الدفتر",
        dvBackHome: "العودة للصفحة الرئيسية",

        // ── Advanced Daily Ledger (kind="daily", variant="advanced") ──
        advKicker: "دفتر تجارة الذهب",
        // ── Voucher (سندات الصرف) ──
        voucherCustomerKicker: "سند صرف عملاء",
        voucherShopKicker: "سند صرف محل",
        voucherCustomerLabel: "سند صرف عملاء",
        voucherShopLabel: "سند صرف محل",
        voucherCustomerTile: "سند صرف عملاء",
        voucherCustomerTileDesc: "سندات صرف للعملاء — كل سند بحقول الاسم والمبلغ والعيار",
        voucherShopTile: "سند صرف محل",
        voucherShopTileDesc: "سندات صرف المحل — للمصاريف الداخلية والموردين",
        voucherNewTitle: "إنشاء سند صرف جديد",
        voucherFillAllRequired: "يرجى تعبئة جميع الحقول المطلوبة",
        voucherSavedToast: "تم حفظ السند بنجاح",
        voucherInvalidType: "نوع السند غير معروف",
        voucherTypeFieldLabel: "نوع السند",
        backToLedgers: "العودة للدفاتر",
        print: "طباعة",
        save: "حفظ",
        advTitle: "دفتر التجارة المتقدم",
        advSalesTitle: "اسم الفرع (البيع)",
        advPurchasesTitle: "اسم الفرع (الشراء)",
        advSalesTitleShort: "البيع",
        advPurchasesTitleShort: "الشراء",
        advCarryOverLabel: "افتتاحي",
        advCarriedFromYesterday: "تم نقل أرصدة اليوم السابق ووزن الكسر تلقائياً",
        advNoPrior: "لا يوجد سجل سابق — يبدأ اليوم من الصفر.",
        advBrokenWeightPlaceholder: "وزن الكسر",
        advBrokenWeightLocked: "مقفل",
        advAddRow: "إضافة صف جديد",
        advColGoldPrice: "سعر الذهب",
        advColMfg: "المصنعية+العمولة",
        advColDesc: "البيان",
        advColWeight: "الوزن",
        advColCash: "كاش",
        advColBank: "بنك",
        advColTransfer: "تحويل",
        advColProfit: "المكسب",
        advColAmount: "المبلغ",
        advColDescGold: "البيان+نوع الذهب",
        advColBrokenWeight: "وزن الكسر",
        advTotalWeight: "مجموع الوزن",
        advTotalCash: "مجموع الكاش",
        advTotalBank: "مجموع البنك",
        advTotalTransfer: "مجموع التحويل",
        advTotalProfit: "مجموع المكسب",
        advTotalAmount: "مجموع المبلغ",
        advTotalBrokenWeight: "وزن الكسر الكلي",
        advCalculateBtn: "احسب",
        advSpending: "الصرف",
        advBalance: "الرصيد",
        advSaveBtn: "حفظ السجل",
        advSavedToast: "تم حفظ سجل التجارة.",
        advCalcDone: "تم حساب الإجماليات والرصيد",
        advCalcEmpty: "أدخل بيانات قبل الحساب",
        advEmpty: "أدخل قيداً واحداً على الأقل قبل الحفظ.",
        advConfirmSave: "هل أنت متأكد من حفظ السجل؟ لا يمكن التعديل بعد الحفظ.",
        advReadOnlyNote: "هذا السجل للقراءة فقط ولا يمكن تعديله بعد الحفظ.",

        // ── Subscription (#84–#89) ──
        subKicker: "اشتراك مطلوب",
        // ── Unsaved-changes 3-way dialog (#3) ──
        dirtySave: "حفظ التغييرات",
        dirtyDiscard: "تجاهل التغييرات",
        dirtyCancel: "إلغاء",

        // ── Admin filters/sort (#6) + delete password (#1) ──
        filterAll: "الكل",
        sortAtoZ: "أ → ي",
        sortZtoA: "ي → أ",
        deletePasswordPrompt: "أدخل كلمة مرور المالك لتأكيد الحذف",
        deletePasswordPlaceholder: "كلمة مرور المالك",
        deletePasswordRequired: "كلمة المرور مطلوبة",

        // ── Registration OTP flow ──
        otpSendBtn: "إرسال رمز التحقّق",
        otpSending: "جاري إرسال الرمز...",
        otpSentToast: "تم إرسال رمز التحقّق إلى هاتفك",
        otpResentToast: "تم إعادة إرسال الرمز",
        otpStepTitle: "تحقّق من رقم هاتفك",
        otpStepSubtitle: "أدخل الرمز المرسل إلى",
        otpFieldLabel: "رمز التحقّق",
        otpInvalidFormat: "رمز التحقّق يجب أن يكون أرقاماً (4-8 خانات)",
        otpVerifyAndCreate: "تحقّق وأنشئ الحساب",
        otpBackToForm: "العودة لتعديل البيانات",
        otpResend: "إعادة إرسال الرمز",
        otpResendIn: "إعادة الإرسال خلال",
        otpVerifyBtn: "تحقّق",
        phoneChangeBtn: "تغيير رقم الهاتف",
        phoneChangeIntro: "أدخل رقم هاتفك الجديد — سيتم إرسال رمز تحقّق للتأكيد.",
        otpTrialNote: "ملاحظة: حساب Twilio في الوضع التجريبي يرسل فقط للأرقام الموثَّقة في لوحة تحكّم Twilio. إن لم تصل الرسالة، تحقّق أن رقمك مضاف هناك.",
        subTitle: "اختر خطة اشتراكك للمتابعة",
        subSubtitle: "بعد إنشاء الحساب، يتعيّن عليك اختيار خطة قبل الوصول للنظام.",
        subTestModeBadge: "وضع تجريبي — لا يتم خصم أي مبالغ فعلية",
        subMonthly: "الخطة الشهرية",
        subYearly: "الخطة السنوية",
        subMonthlyDuration: "30 يوماً",
        subYearlyDuration: "365 يوماً",
        subPerMonth: "شهرياً",
        subPerYear: "سنوياً",
        subFeatureFullAccess: "وصول كامل لجميع الدفاتر والميزات",
        subFeatureUnlimitedLedgers: "عدد غير محدود من السجلات والعملاء",
        subFeatureMonthly: "تجديد كل 30 يوماً — يمكن الترقية في أي وقت",
        subFeatureYearly: "وفّر مقابل دفعة واحدة لمدة سنة كاملة",
        subFeatureTestMode: "وضع تجريبي حالياً — لا حاجة لبيانات بطاقة",
        subSavings: "وفّر",
        subChooseThis: "اختر هذه الخطة",
        subSelected: "تم الاختيار",
        subRequired: "الرجاء اختيار خطة للمتابعة",
        subActivateBtn: "تفعيل الاشتراك",
        subActivatedToast: "تم تفعيل الاشتراك بنجاح",
        subActivateFail: "تعذّر تفعيل الاشتراك",
        subConfirmTitle: "تأكيد تفعيل الاشتراك",
        subConfirmBody: "هل ترغب في تفعيل الخطة المختارة؟ (وضع تجريبي — بدون أي خصم فعلي).",
        subEmployeeNotice: "حسابك حساب موظف — لا تحتاج اشتراكاً، تتمتع بصلاحية الوصول من حساب شركتك.",
        subStatusFree: "حساب مجاني",
        subStatusActive: "اشتراك فعّال",
        subStatusGrace: "فترة سماح",
        subStatusExpired: "منتهي",
        subStatusNone: "غير مشترك",
        subDaysRemaining: "يوم متبقّي",
        subDaysGrace: "يوم سماح",
        subExpiryLabel: "تاريخ الانتهاء",
        subStartLabel: "تاريخ البدء",
        subPriceLabel: "السعر",
        subManageBtn: "إدارة الاشتراك",
        subManageTitle: "إدارة اشتراك الشركة",
        subDefaultsBtn: "أسعار افتراضية",
        subDefaultsTitle: "الأسعار الافتراضية للخطط",
        subDefaultsHint: "تُعرض هذه الأسعار للمستخدمين عند اختيار خطتهم لأول مرة.",
        subDefaultsSaved: "تم حفظ الأسعار الافتراضية",
        subRevoke: "إلغاء الاشتراك",
        subMarkFree: "تعليم كحساب مجاني",
        subUnmarkFree: "إلغاء التعليم المجاني",
        subOverrideSaved: "تم تحديث اشتراك الشركة",
        subOverrideFail: "تعذّر تحديث الاشتراك",
        subPlanLabel: "الخطة",
        subPlanMonthly: "شهري",
        subPlanYearly: "سنوي",
        subPlanNone: "—",
        subExpiredBanner: "اشتراكك منتهٍ — جدّد للمتابعة",
        subGraceBanner: "اشتراكك انتهى — تتبقّى لك أيام سماح قبل إيقاف الوصول",

        // ── Sorting / Filtering (Records) ───────────────────
        sortFilterBtn: "فرز",
        sortFilterAll: "عرض الكل",
        sortFilterAToZ: "أ → ي (تصاعدي)",
        sortFilterZToA: "ي → أ (تنازلي)",
        sortFilterGoldOwed: "لهم ذهب",
        sortFilterGoldOwing: "عليهم ذهب",
        sortFilterCashOwed: "لهم كاش",
        sortFilterCashOwing: "عليهم كاش",
        sortFilterAlphabetGroup: "ترتيب أبجدي",
        sortFilterGoldGroup: "حالة الذهب",
        sortFilterCashGroup: "حالة الكاش",
        sortFilterEmpty: "لا توجد سجلات مطابقة للفلتر",

        // ── Account types (Manager / Employee / Individual) ──
        accountTypeTitle: "نوع الحساب",
        accountTypePickerTitle: "اختر نوع حسابك",
        accountTypePickerSubtitle: "اختر النوع الذي يصف عملك للمتابعة في إنشاء الحساب.",
        accountTypeManager: "مدير شركة",
        accountTypeManagerDesc: "لأصحاب الأعمال الذين يديرون محلاً أو عدة محلات. صلاحيات كاملة على جميع الدفاتر وحسابات الموظفين.",
        accountTypeEmployee: "موظف",
        accountTypeEmployeeDesc: "للموظفين العاملين تحت إدارة شركة. صلاحيات محدودة حسب إذن الشركة.",
        accountTypeIndividual: "منفرد",
        accountTypeIndividualDesc: "لمستخدم فردي يدير سجلاته الخاصة. بدون موظفين ولا مشاركة.",
        accountTypeContinue: "متابعة",
        accountTypeBackHome: "← العودة لتسجيل الدخول",
        accountTypeRequired: "الرجاء اختيار نوع الحساب",
        accountTypeLocked: "نوع الحساب مقفل — لا يمكن التعديل",
        saveAccountType: "حفظ نوع الحساب",
        accountTypeSettingsHint: "اختر نوع حسابك — يُحفظ مرّة واحدة فقط.",
        // Employee registration
        employeeRegisterTitle: "تسجيل موظف",
        employeeLoginTitle: "تسجيل الدخول",
        employeeNameLabel: "اسم الموظف",
        employeeNamePlaceholder: "اسم الموظف الكامل",
        employeeCodeLabel: "رمز الشركة",
        employeeCodePlaceholder: "ABC123",
        employeeAccessLabel: "كلمة وصول الشركة",
        employeeAccessPlaceholder: "كلمة الوصول التي تسلّمتها من المدير",
        employeeLoginLink: "هل أنت موظف؟ تسجيل دخول",
        // Manager settings
        managerCompanyAccessTitle: "إعدادات الموظفين",
        managerEmployeeLimitLabel: "عدد الموظفين المسموح",
        managerAccessPasswordLabel: "كلمة وصول الشركة",
        managerAccessPasswordPlaceholder: "كلمة سيستخدمها الموظفون للانضمام",
        managerCompanyCodeLabel: "رمز شركتك",
        managerCompanyCodeHint: "أعطِ هذا الرمز لموظفيك إلى جانب كلمة الوصول.",
        managerCompanyAccessSaved: "تم حفظ إعدادات الموظفين.",
        managerSaveAccess: "حفظ الإعدادات",
        // Employee records (manager view)
        employeeRecordsKicker: "إدارة",
        employeeRecordsTitle: "سجلات الموظفين",
        employeeRecordsSubtitle: "اعرض السجلات اليومية لموظفيك (عرض فقط).",
        employeeRecordsEmpty: "لم ينضم أي موظف بعد",
        employeeRecordsEmptyHint: "أعطِ موظفيك رمز الشركة وكلمة الوصول للانضمام.",
        employeeDailyCount: "سجلات يومية",
        employeeJoinedAt: "انضم في:",
        managerNoAccessSetup: "حدّد عدد الموظفين أولاً من الإعدادات.",
        backToEmployees: "← العودة للموظفين",

        // ── TOTP (Google Authenticator) — #92 ─────────────────
        emailLabel: "البريد الإلكتروني",
        emailHint: "نستخدمه فقط لاستعادة الحساب — لن يتم إرسال أي رسائل تسويقية.",
        emailRequired: "الرجاء إدخال بريد إلكتروني صالح",
        passwordTooShort: "كلمة المرور قصيرة جداً (4 أحرف على الأقل)",
        registerSubmit: "إنشاء الحساب",
        registerLoading: "جاري الإنشاء...",
        registerTotpNote: "بعد إنشاء الحساب، ستحتاج إلى إعداد المصادقة الثنائية عبر Google Authenticator.",
        loginSuccess: "تم تسجيل الدخول",

        // TOTP setup screen
        totpSetupTitle: "إعداد المصادقة الثنائية",
        totpSetupSubtitle: "افحص رمز QR ببرنامج Google Authenticator (أو Authy / 1Password) لربط حسابك.",
        totpSetupStep1: "الخطوة 1 — افحص رمز QR",
        totpSetupStep1Hint: "افتح Google Authenticator → + → افحص رمز QR.",
        totpSetupStep2: "الخطوة 2 — أدخل الرمز الأول",
        totpSetupStep2Hint: "أدخل الرمز المكوّن من 6 أرقام الذي يظهر في التطبيق.",
        totpSecretLabel: "أو أدخل المفتاح يدوياً:",
        totpActivateBtn: "تفعيل المصادقة الثنائية",
        totpEnabledToast: "تم تفعيل المصادقة الثنائية بنجاح",
        totpEnabledBanner: "تم تفعيل المصادقة الثنائية — احفظ رموز الاستعادة قبل المتابعة.",
        totpBackupCodesTitle: "رموز الاستعادة (6 رموز)",
        totpBackupCodesSubtitle: "كل رمز يستخدم مرة واحدة فقط. احفظها في مكان آمن — لن تظهر مرة أخرى.",
        totpBackupCodesFootnote: "كل رمز يستعمل مرة واحدة. لا تشاركها مع أحد.",
        totpCopyAll: "نسخ الكل",
        totpDownloadTxt: "تنزيل (.txt)",
        totpAckSaved: "لقد حفظت رموز الاستعادة في مكان آمن.",
        totpFinishSetup: "متابعة",
        copiedToast: "تم النسخ",

        // TOTP challenge screen (after login)
        totpChallengeTitle: "تحقّق ثنائي",
        totpChallengeSubtitle: "افتح Google Authenticator وأدخل الرمز الحالي (6 أرقام).",
        totpBackupSubtitle: "أدخل أحد رموز الاستعادة (يستخدم مرة واحدة).",
        totpCodeLabel: "رمز التحقّق",
        totpCodeHint: "الرمز يتغيّر كل 30 ثانية تلقائياً.",
        totpBackupLabel: "رمز الاستعادة",
        totpBackupHint: "مثال: ABCD-EFGH",
        totpVerifyAndLogin: "تحقّق وتسجيل الدخول",
        totpUseBackupBtn: "هل فقدت هاتفك؟ استخدم رمز استعادة",
        totpUseCodeBtn: "← العودة لاستخدام Authenticator",
        totpBackToLogin: "عودة لتسجيل الدخول",
        totpInvalidFormat: "أدخل رمزاً مكوّناً من 6 أرقام",
        totpBackupRequired: "أدخل رمز الاستعادة",
        totpBackupUsedWarning: "تم تسجيل الدخول باستخدام رمز استعادة — يُنصح بتجديد رموزك من الإعدادات.",

        // ── Account email association in QR + recovery (#93) ─────
        totpAccountInAuth: "سيظهر الحساب في Authenticator باسم",
        locationRequired: "الرجاء اختيار الدولة والمدينة",
        recoverLink: "نسيت كلمة المرور؟",
        recoverNowBtn: "ابدأ استعادة الحساب الآن",
        recoverTitle: "استعادة الحساب",
        recoverSubtitle: "إعادة تعيين كلمة المرور بالتحقق من المصادقة الثنائية",
        recoverStep1Label: "تحديد الحساب",
        recoverStep2Label: "التحقّق بـ TOTP",
        recoverStep3Label: "كلمة مرور جديدة",
        recoverStep1Hint: "أدخل اسم الشركة والبريد الإلكتروني المُسجّل.",
        recoverStep2Hint: "افتح Google Authenticator وأدخل الرمز الحالي (6 أرقام).",
        recoverStep3Hint: "اختر كلمة مرور جديدة. ستحتاج لإدخالها في تسجيل الدخول المرّة القادمة.",
        recoverFieldsRequired: "الرجاء إدخال اسم الشركة والبريد الإلكتروني",
        recoverContinueBtn: "متابعة",
        recoverVerifyBtn: "تأكيد الرمز",
        recoverSavePasswordBtn: "حفظ كلمة المرور",
        recoverNewPasswordLabel: "كلمة المرور الجديدة",
        recoverPasswordChangedToast: "تم تغيير كلمة المرور — يمكنك الآن تسجيل الدخول",

        // ── In-Settings TOTP enrolment for whitelisted accounts (#95) ──
        settingsTotpTitle: "تفعيل المصادقة الثنائية (TOTP)",
        settingsTotpSubtitle: "أضِف طبقة حماية إضافية لحسابك عبر Google Authenticator. يستخدم الرمز لإجراءات حسّاسة واستعادة الحساب.",
        settingsTotpStep1: "تأكيد البريد",
        settingsTotpStep2: "افحص QR",
        settingsTotpStep3: "رموز الاستعادة",
        settingsTotpStep1Hint: "للتأكد من ملكيتك للحساب، أعد إدخال البريد الإلكتروني المسجّل.",
        settingsTotpStep2Hint: "افحص رمز QR ببرنامج Google Authenticator، ثم أدخل الرمز المكوّن من 6 أرقام.",
        settingsTotpVerifyEmailBtn: "تأكيد البريد ومتابعة",
        settingsTotpBackupTitle: "احفظ رموز الاستعادة (6 رموز)",
    },

    en: {
        dir: "ltr",
        // ── Branding / shared ────────────────────────────────
        brand: "Meyar",
        brandTag: "Al Meyar • Gold Accounting System",
        brandSubtitle:
            "Manage client ledgers with professional precision.",

        // ── Auth ────────────────────────────────────────────
        loginAppTagline: "Gold Accounting System",
        loginTitle: "Sign in",
        loginSubtitle: "Enter your company credentials to access the ledger.",
        companyLabel: "Company name",
        companyPlaceholder: "Elegant Gold Co.",
        passwordLabel: "Password",
        passwordPlaceholder: "••••••••",
        loginSubmit: "Sign in",
        loginSubmitLoading: "Signing in...",
        loginNoAccount: "Don't have an account?",
        loginGoRegister: "Create a new account",
        registerAppTagline: "Create a new company account",
        registerTitle: "New account",
        registerSubtitle:
            "Register your company name and password to get started.",
        confirmPasswordLabel: "Confirm password",
        registerSubmit: "Create account",
        registerSubmitLoading: "Creating...",
        registerHaveAccount: "Already have an account?",
        registerGoLogin: "Sign in",
        passwordMismatch: "Passwords do not match",
        toggleAria: "Change language",
        toggleNext: "ع",

        // ── Phone / Location ────────────────────────────────
        phoneLabel: "Phone number",
        phonePlaceholder: "+96891234567",
        phoneInvalid: "Invalid phone number",
        phoneRequired: "Phone number is required",
        countryLabel: "Country",
        cityLabel: "City",
        countryPlaceholder: "Select a country...",
        cityPlaceholder: "Select a city...",
        searchCountry: "Search country...",
        searchCity: "Search city...",
        locationLabel: "Location (Country - City)",
        locationLocked: "Locked — cannot be edited",
        phoneLocked: "Locked — cannot be edited",
        savePhone: "Save phone number",
        saveLocation: "Save location",
        phoneSetTitle: "Complete your profile — phone number",
        phoneSetHint: "Add a phone number so you can recover your password if you forget it. Saved once and cannot be changed later.",
        locationSetTitle: "Complete your profile — location",
        locationSetHint: "Pick the country, then the city. Saved once and cannot be changed later.",
        phoneSavedToast: "Phone number saved.",
        phoneEditOnceHint: "You can edit your phone number once. It will be locked permanently afterwards.",
        phoneCurrent: "Current",
        locationSavedToast: "Location saved.",

        // ── Forgot password ─────────────────────────────────
        forgotLink: "Forgot password?",
        forgotTitle: "Reset password",
        forgotPhoneStep: "Enter your account name and phone number",
        forgotPhoneHint: "We'll verify both and send a code to the registered phone.",
        forgotSendOtp: "Send code",
        forgotOtpStep: "Enter the verification code",
        forgotOtpHint: "Check your SMS and enter the 6-digit code.",
        forgotOtpLabel: "Verification code",
        forgotVerify: "Verify",
        forgotResend: "Resend",
        forgotResendIn: "Resend in {s}s",
        forgotResetStep: "Choose a new password",
        forgotResetHint: "Enter and confirm the new password.",
        forgotResetSubmit: "Save new password",
        forgotBackToLogin: "Back to sign in",
        forgotDoneToast: "Password updated. Sign in with your new password.",
        forgotDevOtpHint: "Dev mode: your code is {otp}",

        // ── App Shell ───────────────────────────────────────
        navLedger: "Ledgers",
        navHistory: "Records",
        navSettings: "Settings",
        navLogout: "Logout",

        // ── Picker pages ────────────────────────────────────
        pickerLedgersKicker: "Ledgers",
        pickerLedgersTitle: "Choose a ledger",
        pickerLedgersSubtitle: "Open Client, Factory or Daily Movement ledger.",
        pickerRecordsKicker: "Archive",
        pickerRecordsTitle: "Records",
        pickerRecordsSubtitle: "View Client, Factory or Daily Movement records.",
        clientLedgerTitle: "Client Ledger",
        clientLedgerSubtitle: "Client accounts (gold only).",
        factoryLedgerTitle: "Factory Ledger",
        factoryLedgerSubtitle: "Factory accounts (gold + fees).",
        dailyLedgerTitle: "Daily Movement",
        dailyLedgerSubtitle: "Daily cash-box movement (sales / expenses / purchases).",
        clientRecordsTitle: "Client Records",
        clientRecordsSubtitle: "Saved entries from the Client Ledger.",
        factoryRecordsTitle: "Factory Records",
        factoryRecordsSubtitle: "Saved entries from the Factory Ledger.",
        dailyRecordsTitle: "Daily Records",
        dailyRecordsSubtitle: "Saved daily movement records (read-only).",
        backToPicker: "Ledgers",
        backToRecordsPicker: "Records",

        // ── Ledger page ─────────────────────────────────────
        ledgerKicker: "Account Ledger",
        ledgerTitle: "New page",
        ledgerSubtitle:
            'Enter the client name and add entries, then click "Save" to archive the record. You can re-open and edit it later.',
        ledgerEmpty: "Empty page",
        ledgerSaveBtn: "Save ledger",
        clientNameLabel: "Client name",
        clientNamePlaceholder: "Type the client name...",
        pageDate: "Page date",
        creditTitle: "Owed to client",
        debitTitle: "Owed by client",
        goldChip: "GOLD",
        cashChip: "CASH",
        netGoldLabel: "Net gold (credit − debit)",
        netFeesLabel: "Net fees (credit − debit)",
        forLabel: "Credit:",
        againstLabel: "Debit:",
        toastNeedClient: "Please enter the client name before saving.",
        toastEmptyLedger: "The ledger is empty — add at least one row.",
        toastSaved: "Ledger saved to the archive.",
        toastSaveFail: "Could not save.",

        // ── LedgerTable ─────────────────────────────────────
        colKaratType: "Karat type",
        colWeight: "Weight",
        colKarat: "Karat",
        colResult: "Result",
        colManufacturing: "Workmanship",
        colDescription: "Description",
        colInvoice: "Invoice #",
        colFees: "Fees",
        colGoldReceived: "Gold received",
        colDate: "Date",
        rowsOne: "row",
        rowsMany: "rows",
        addRow: "Add row",
        deleteRow: "Delete row",
        emptyTable: 'No entries yet. Click "Add row" to start.',
        totalFees: "Total fees",
        rowWord: "Row",
        cellWord: "Cell",
        navUp: "Up",
        navDown: "Down",
        navPrev: "Previous",
        navNext: "Next",

        // ── History ─────────────────────────────────────────
        historyKicker: "Archive",
        historyTitle: "Saved records",
        historySubtitle: "Search previous pages by client name.",
        historySearchPlaceholder: "Search by client name...",
        historyEmptyTitle: "No records",
        historyEmptyHint: "Save a page from the ledger to see it here.",
        deleteWord: "Delete",

        // ── HistoryDetail ───────────────────────────────────
        backToHistory: "Records",
        editKicker: "Edit record",
        editFallbackTitle: "Record",
        createdLabel: "Created:",
        updatedLabel: "Last edit:",
        saveChanges: "Save changes",
        toastNeedClientEdit: "Please enter the client name.",
        toastEmptyEdit: "Record is empty — add at least one row.",
        toastEditSaved: "Changes saved.",
        toastEditFail: "Could not save the changes.",
        netGoldShort: "Net gold",
        netFeesShort: "Net fees",

        // ── Settings ────────────────────────────────────────
        backToLedger: "Ledger",
        settingsKicker: "Settings",
        settingsTitle: "Settings",
        settingsSubtitle: "Manage company account",
        accountSecurity: "Account security",
        accountSecurityHint:
            "Change your password regularly to keep the ledger safe.",
        secTip1: "Use 8 characters or more",
        secTip2: "Mix letters and numbers",
        secTip3: "Never share it with anyone",
        changePassword: "Change password",
        changePasswordHint:
            "Enter your current password then the new one. You will be signed out after the change.",
        currentPassword: "Current password",
        newPassword: "New password",
        confirmNewPassword: "Confirm new password",
        clearBtn: "Clear",
        saveNewPassword: "Save new password",
        passwordChangedToast:
            "Password changed successfully. Please sign in again.",
        allFieldsRequired: "All fields are required",
        newPasswordTooShort:
            "New password is too short (at least 4 characters)",
        passwordsDontMatch: "Passwords do not match",
        newPasswordSameAsCurrent:
            "The new password matches the current one",
        changePasswordFail: "Could not change the password",

        deletionCodeTitle: "Deletion code",
        deletionCodeHint:
            "A separate code required before deleting any archived record. The default is your password — we recommend changing it.",
        newDeletionCode: "New deletion code",
        confirmDeletionCode: "Confirm code",
        saveDeletionCode: "Save deletion code",
        deletionCodeShort:
            "Deletion code is too short (at least 4 characters)",
        codesDontMatch: "The codes do not match",
        currentPasswordWrong: "Current password is incorrect",
        deletionCodeUpdated: "Deletion code updated.",
        deletionCodeUpdateFail: "Could not update the deletion code",

        dangerZoneTitle: "Danger zone — Delete account",
        dangerZoneHint1:
            "The company account and every saved record will be permanently deleted with no way to recover them.",
        dangerZoneHint2: "The company name",
        dangerZoneHint3: "will become available again.",
        deleteAccount: "Delete account",
        deleteAccountConfirmTitle: "Confirm account deletion",
        irreversible: "cannot be undone",
        actionWillDelete: "This action",
        sectorsDeleted: "Will be deleted:",
        bullet1: "Company account and password",
        bullet2: "All saved records and pages",
        enterPasswordToConfirm: "Enter your password to confirm:",
        cancel: "Cancel",
        deleteForever: "Yes, delete permanently",
        accountDeletedToast:
            "Account deleted. The company name can be reused.",
        accountDeleteFail: "Could not delete the account",
        passwordRequired: "Please enter your password to confirm",

        // ── Logout confirmation ─────────────────────────────
        logoutConfirmTitle: "Confirm sign out",
        logoutConfirmBody: "Are you sure you want to sign out of this account?",
        logoutConfirmOk: "Yes, sign out",

        // ── Preferences (language + theme) ──────────────────
        preferencesTitle: "Preferences",
        preferencesHint: "Choose the display language and theme (light/dark).",
        languageLabel: "Display language",
        themeLabel: "App theme",
        themeLight: "Light",
        themeDark: "Dark",

        // ── Delete-account OTP step ─────────────────────────
        deleteAccountOtpIntro: "To permanently delete your account, we'll send a verification code to your registered phone.",
        deleteAccountOtpStep: "Enter the verification code sent to",
        deleteAccountSendOtp: "Send verification code",
        deleteAccountConfirmFinal: "Confirm deletion",

        // ── Invoices (owner-only) ───────────────────────────
        invoicesNavBtn: "Invoices",
        invoicesTitle: "Invoices Log",
        invoicesSubtitle: "All subscription and renewal invoices. Owner password is required to delete.",
        invoicesKicker: "Owner Panel",
        invoicesEmpty: "No invoices yet",
        invoicesEmptyHint: "Invoices will appear automatically with each subscription or renewal.",
        invoicesSearchPlaceholder: "Search by company name...",
        invoicesFilterAll: "All",
        invoicesFilterNew: "New subscription",
        invoicesFilterRenewal: "Renewal",
        invoicesActionNew: "New",
        invoicesActionRenewal: "Renewal",
        invoicesSortBy: "Sort by",
        invoicesSortDate: "Date",
        invoicesSortCompany: "Company",
        invoicesSortPrice: "Price",
        invoicesSortDirAsc: "Ascending",
        invoicesSortDirDesc: "Descending",
        invoicesColNumber: "Invoice #",
        invoicesColCompany: "Company",
        invoicesColPhone: "Phone",
        invoicesColDate: "Date",
        invoicesColAction: "Type",
        invoicesColPlan: "Plan",
        invoicesColPrice: "Price",
        invoicesColActions: "Actions",
        invoicesDeleteBtn: "Delete",
        invoicesCountChip: "invoice(s)",
        invoicesTotalRevenue: "Total revenue",
        invoicesDeleteConfirmTitle: "Delete invoice",
        invoicesDeleteConfirmBody: "Are you sure you want to delete this invoice? This action cannot be undone.",
        invoicesDeleteOwnerPwLabel: "Re-enter owner password to confirm",
        invoicesDeleteConfirmOk: "Confirm delete",
        invoicesDeletedToast: "Invoice deleted.",
        invoicesPlanMonthly: "Monthly",
        invoicesPlanYearly: "Yearly",
        // Company subscription stat chips (in AdminAccounts cards)
        statsTotalSubs: "Total subscriptions",
        statsNewSubs: "New",
        statsRenewalSubs: "Renewal",

        // ── Delete Ledger Dialog ────────────────────────────
        deleteEnterCode: "Enter the deletion code to continue",
        deleteEnterCodeHint:
            "To protect your data, you must enter the company deletion code before removing any record.",
        deletionCodeFieldLabel: "Deletion code",
        nextBtn: "Next",
        defaultDeletionCodeNote:
            "The default deletion code is your password. You can change it from Settings.",
        enterCodePlease: "Please enter the deletion code",
        confirmDeleteTitle: "Delete this record?",
        confirmDeleteHint:
            "The record will be deleted safely. An administrator can restore it later if needed.",
        recordLabel: "Record:",
        no: "No",
        yesDelete: "Yes, delete",
        deletedToast: "Record deleted",
        deleteFail: "Could not delete",

        // ── DirtyContext dialog ─────────────────────────────
        saveDataTitle: "Do you want to save this data?",
        saveEditsTitle: "Do you want to save the changes?",
        unsavedHint:
            'You have unsaved changes. Choose "Yes" to save before continuing, or "No" to continue without saving.',
        yes: "Yes",

        // ── Admin Accounts ──────────────────────────────────
        ownerPanelKicker: "Owner panel",
        accountsLogTitle: "Accounts log",
        accountsLogSubtitle:
            "List of every company registered on the platform with their join date. You can delete any account — the account and all of its records will be removed permanently.",
        searchCompanyPlaceholder: "Search by company name...",
        companiesWord: "companies",
        noMatchingAccounts: "No matching accounts",
        noMatchingHint:
            "Try a different name, or clear the search field to show all accounts.",
        joinedAt: "Joined:",
        phoneLine: "Phone:",
        emailLine: "Email:",
        locationLine: "Location:",
        createdAtLine: "Created:",
        notSet: "—",
        adminDeleteWillDelete1: "Company account",
        adminDeleteWillDelete2: "All saved records and pages for this account",
        adminDeleteCompanyFreed: "The company name will become available again.",
        adminAccountDeletedToast: "Account deleted",
        adminAccountDeleteFail: "Could not delete the account",

        // ── Daily Movement Ledger ───────────────────────────
        dailyKicker: "Cash-box movement",
        dailyPageTitle: "Daily Movement",
        dailyDateLabel: "Date:",
        dailySalesTitle: "Sales",
        dailyExpensesTitle: "Expenses",
        dailyPurchasesTitle: "Purchases",
        dailyColIdx: "#",
        dailyColDesc: "Description",
        dailyColGram: "Gram",
        dailyColCash: "Cash",
        dailyColTransfer: "Transfer",
        dailyColBank: "Bank",
        dailyColWeight: "Weight",
        dailyExportLabel: "Carry-over",
        dailyTotalLabel: "Total",
        dailySpendingLabel: "Spending",
        dailyBalanceLabel: "Balance",
        dailyCalculateBtn: "Calculate",
        dailySaveBtn: "Save daily record",
        dailySavedToast: "Daily record saved.",
        dailySaveFail: "Could not save the record",
        dailyReadOnlyBadge: "Read-only",
        dailyReadOnlyNote: "Daily records are read-only and cannot be edited after saving.",
        dailyCarriedFromYesterday: "Previous day's balances were carried over automatically",
        dailyNoPrior: "No prior daily record — starting from zero.",
        dailyDateRequired: "Date is required",
        dailyEmpty: "Enter at least one entry before saving.",
        dailyConfirmSave: "Choose how to save:",

        // ── Two-stage save (#91): Final / Editable / Ignore / Cancel ──
        saveDialogTitle: "Save record",
        saveDialogSubtitle: "Pick a save mode:",
        saveOptionFinal: "Save Final",
        saveOptionFinalHint: "Lock the record permanently — no edits afterwards.",
        saveOptionEditable: "Save Editable",
        saveOptionEditableHint: "Save as a draft you can edit later.",
        saveOptionIgnore: "Ignore",
        saveOptionIgnoreHint: "Discard changes and go back without saving.",
        // Status chips
        statusFinalChip: "Locked",
        statusEditableChip: "Editable",
        // Edit button
        editRecordBtn: "Edit record",
        ledgerSavedEditable: "Saved as editable draft.",

        // ── Ledger mode selection ───────────────────────────
        ledgerModeLabel: "Ledger mode",
        ledgerModeFull: "Client + Factory + Daily Movement",
        ledgerModeBasic: "Client + Factory only",
        ledgerModeHint: "Choose the ledgers you'll use — saved once and locked permanently.",
        ledgerModeRequired: "Please choose a ledger mode",
        ledgerModeSaved: "Ledger mode saved.",
        ledgerModeLocked: "Ledger mode is locked — cannot be edited",
        ledgerModeSettingsHint: "Choose which ledgers to enable — saved once only.",
        saveLedgerMode: "Save ledger mode",
        dailyDisabledForAccount: "Daily Movement is not enabled for this account",

        // ── Daily-variant picker (standard vs advanced) ─────
        dvKicker: "Choose your daily ledger",
        dvTitle: "Standard Daily Ledger or Advanced Trading Ledger",
        dvSubtitle: "One-time selection — locked permanently after saving.",
        dvStandardTitle: "Standard Daily Ledger",
        dvStandardDesc: "Classic ledger to track sales, expenses, and purchases.",
        dvStandardBullet1: "Sections: Sales, Expenses, Purchases",
        dvStandardBullet2: "Automatic carry-over of previous-day balances",
        dvStandardBullet3: "Quick end-of-day balance calculation",
        dvAdvancedTitle: "Advanced Trading Ledger",
        dvAdvancedDesc: "Advanced trading ledger with profit, balance, and detailed gold operations.",
        dvAdvancedBullet1: "Per-row profit calculation on sales",
        dvAdvancedBullet2: "Gold price, manufacturing fee, and broken weight",
        dvAdvancedBullet3: "“Calculate” button auto-generates totals and balance",
        dvSelect: "Choose this ledger",
        dvSelectedBadge: "Selected",
        dvLockedHint: "Variant is locked — cannot be edited",
        dvSaveBtn: "Confirm selection",
        dvConfirmTitle: "Confirm daily ledger variant",
        dvConfirmBody: "Are you sure? The daily-ledger variant cannot be changed after saving.",
        dvSavedToast: "Daily-ledger variant saved.",
        dvSaveFail: "Could not save the selection",
        dvRequired: "Please choose a ledger variant to continue",
        dvPreviewAlt: "Ledger preview",
        dvBackHome: "Back to home",

        // ── Advanced Daily Ledger (kind="daily", variant="advanced") ──
        advKicker: "Gold trading ledger",
        // ── Voucher (Payment Vouchers) ──
        voucherCustomerKicker: "Customer Payment Voucher",
        voucherShopKicker: "Shop Payment Voucher",
        voucherCustomerLabel: "Customer Voucher",
        voucherShopLabel: "Shop Voucher",
        voucherCustomerTile: "Customer Voucher",
        voucherCustomerTileDesc: "Payment vouchers for customers — name, amount and purity per slip",
        voucherShopTile: "Shop Voucher",
        voucherShopTileDesc: "Shop payment vouchers — for internal expenses and suppliers",
        voucherNewTitle: "New payment voucher",
        voucherFillAllRequired: "Please fill all required fields",
        voucherSavedToast: "Voucher saved",
        voucherInvalidType: "Unknown voucher type",
        voucherTypeFieldLabel: "Voucher type",
        backToLedgers: "Back to ledgers",
        print: "Print",
        save: "Save",
        advTitle: "Advanced Trading Ledger",
        advSalesTitle: "Branch (Sales)",
        advPurchasesTitle: "Branch (Purchases)",
        advSalesTitleShort: "Sales",
        advPurchasesTitleShort: "Purchases",
        advCarryOverLabel: "Opening",
        advCarriedFromYesterday: "Previous day's balances and broken-weight were carried over automatically",
        advNoPrior: "No prior record — starting from zero.",
        advBrokenWeightPlaceholder: "Broken weight",
        advBrokenWeightLocked: "Locked",
        advAddRow: "Add new row",
        advColGoldPrice: "Gold Price",
        advColMfg: "Mfg + Commission",
        advColDesc: "Description",
        advColWeight: "Weight",
        advColCash: "Cash",
        advColBank: "Bank",
        advColTransfer: "Transfer",
        advColProfit: "Profit",
        advColAmount: "Amount",
        advColDescGold: "Description + Gold type",
        advColBrokenWeight: "Broken weight",
        advTotalWeight: "Total weight",
        advTotalCash: "Total cash",
        advTotalBank: "Total bank",
        advTotalTransfer: "Total transfer",
        advTotalProfit: "Total profit",
        advTotalAmount: "Total amount",
        advTotalBrokenWeight: "Total broken weight",
        advCalculateBtn: "Calculate",
        advSpending: "Spending",
        advBalance: "Balance",
        advSaveBtn: "Save record",
        advSavedToast: "Trading record saved.",
        advCalcDone: "Totals and balance calculated",
        advCalcEmpty: "Enter data before calculating",
        advEmpty: "Enter at least one entry before saving.",
        advConfirmSave: "Save this record? It cannot be edited after saving.",
        advReadOnlyNote: "This record is read-only and cannot be edited after saving.",

        // ── Subscription (#84–#89) ──
        subKicker: "Subscription required",
        // ── Unsaved-changes 3-way dialog (#3) ──
        dirtySave: "Save changes",
        dirtyDiscard: "Discard changes",
        dirtyCancel: "Cancel",

        // ── Admin filters/sort (#6) + delete password (#1) ──
        filterAll: "All",
        sortAtoZ: "A → Z",
        sortZtoA: "Z → A",
        deletePasswordPrompt: "Enter owner password to confirm deletion",
        deletePasswordPlaceholder: "Owner password",
        deletePasswordRequired: "Password is required",

        // ── Registration OTP flow ──
        otpSendBtn: "Send verification code",
        otpSending: "Sending code...",
        otpSentToast: "Verification code sent to your phone",
        otpResentToast: "Code resent",
        otpStepTitle: "Verify your phone",
        otpStepSubtitle: "Enter the code sent to",
        otpFieldLabel: "Verification code",
        otpInvalidFormat: "Code must be 4–8 digits",
        otpVerifyAndCreate: "Verify & create account",
        otpBackToForm: "Back to form",
        otpResend: "Resend code",
        otpResendIn: "Resend in",
        otpVerifyBtn: "Verify",
        phoneChangeBtn: "Change phone number",
        phoneChangeIntro: "Enter your new phone number — a verification code will be sent.",
        otpTrialNote: "Note: Twilio trial accounts can only send SMS to numbers verified in the Twilio console. If you don't receive the code, make sure your number is verified.",
        subTitle: "Choose your subscription plan to continue",
        subSubtitle: "After creating your account, please pick a plan before accessing the system.",
        subTestModeBadge: "Test mode — no real charges are made",
        subMonthly: "Monthly Plan",
        subYearly: "Yearly Plan",
        subMonthlyDuration: "30 days",
        subYearlyDuration: "365 days",
        subPerMonth: "per month",
        subPerYear: "per year",
        subFeatureFullAccess: "Full access to all ledgers and features",
        subFeatureUnlimitedLedgers: "Unlimited records and clients",
        subFeatureMonthly: "Renews every 30 days — upgrade anytime",
        subFeatureYearly: "Single payment covering a full year",
        subFeatureTestMode: "Currently in test mode — no card details required",
        subSavings: "Save",
        subChooseThis: "Choose this plan",
        subSelected: "Selected",
        subRequired: "Please pick a plan to continue",
        subActivateBtn: "Activate subscription",
        subActivatedToast: "Subscription activated successfully",
        subActivateFail: "Could not activate the subscription",
        subConfirmTitle: "Confirm subscription activation",
        subConfirmBody: "Activate the selected plan? (Test mode — no real charges).",
        subEmployeeNotice: "You're logged in as an employee — no subscription needed; you inherit access from your company.",
        subStatusFree: "Free account",
        subStatusActive: "Active",
        subStatusGrace: "Grace period",
        subStatusExpired: "Expired",
        subStatusNone: "Not subscribed",
        subDaysRemaining: "days remaining",
        subDaysGrace: "days of grace",
        subExpiryLabel: "Expiry date",
        subStartLabel: "Start date",
        subPriceLabel: "Price",
        subManageBtn: "Manage subscription",
        subManageTitle: "Manage company subscription",
        subDefaultsBtn: "Default prices",
        subDefaultsTitle: "Default plan prices",
        subDefaultsHint: "Shown to new users when choosing their first plan.",
        subDefaultsSaved: "Default prices saved",
        subRevoke: "Revoke subscription",
        subMarkFree: "Mark as free account",
        subUnmarkFree: "Unmark free",
        subOverrideSaved: "Company subscription updated",
        subOverrideFail: "Could not update the subscription",
        subPlanLabel: "Plan",
        subPlanMonthly: "Monthly",
        subPlanYearly: "Yearly",
        subPlanNone: "—",
        subExpiredBanner: "Your subscription has expired — renew to continue",
        subGraceBanner: "Subscription expired — limited grace period remaining before access is blocked",

        // ── Sorting / Filtering (Records) ───────────────────
        sortFilterBtn: "Sort / Filter",
        sortFilterAll: "Show all",
        sortFilterAToZ: "A → Z",
        sortFilterZToA: "Z → A",
        sortFilterGoldOwed: "Has Gold",
        sortFilterGoldOwing: "Owes Gold",
        sortFilterCashOwed: "Has Cash",
        sortFilterCashOwing: "Owes Cash",
        sortFilterAlphabetGroup: "Alphabetical",
        sortFilterGoldGroup: "Gold status",
        sortFilterCashGroup: "Cash status",
        sortFilterEmpty: "No records match the selected filter",

        // ── Account types ───────────────────────────────────
        accountTypeTitle: "Account type",
        accountTypePickerTitle: "Choose your account type",
        accountTypePickerSubtitle: "Pick the option that best describes your business to continue.",
        accountTypeManager: "Company Manager",
        accountTypeManagerDesc: "For owners managing one or many shops. Full access to ledgers and employees.",
        accountTypeEmployee: "Employee",
        accountTypeEmployeeDesc: "For employees working under a company. Limited access set by the manager.",
        accountTypeIndividual: "Individual",
        accountTypeIndividualDesc: "For solo users managing their own records. No employees, no sharing.",
        accountTypeContinue: "Continue",
        accountTypeBackHome: "← Back to login",
        accountTypeRequired: "Please select an account type",
        accountTypeLocked: "Account type locked — cannot be changed",
        saveAccountType: "Save account type",
        accountTypeSettingsHint: "Pick your account type — saved once only.",
        employeeRegisterTitle: "Employee registration",
        employeeLoginTitle: "Sign in",
        employeeNameLabel: "Employee name",
        employeeNamePlaceholder: "Employee full name",
        employeeCodeLabel: "Company code",
        employeeCodePlaceholder: "ABC123",
        employeeAccessLabel: "Company access password",
        employeeAccessPlaceholder: "The access password your manager gave you",
        employeeLoginLink: "Are you an employee? Sign in",
        managerCompanyAccessTitle: "Employee settings",
        managerEmployeeLimitLabel: "Allowed employees",
        managerAccessPasswordLabel: "Company access password",
        managerAccessPasswordPlaceholder: "Password employees use to join",
        managerCompanyCodeLabel: "Your company code",
        managerCompanyCodeHint: "Share this code with your employees along with the access password.",
        managerCompanyAccessSaved: "Employee settings saved.",
        managerSaveAccess: "Save settings",
        employeeRecordsKicker: "Management",
        employeeRecordsTitle: "Employee Records",
        employeeRecordsSubtitle: "View your employees' daily movement records (read-only).",
        employeeRecordsEmpty: "No employees joined yet",
        employeeRecordsEmptyHint: "Give them your company code + access password to join.",
        employeeDailyCount: "Daily records",
        employeeJoinedAt: "Joined at:",
        managerNoAccessSetup: "Set the employee limit first from Settings.",
        backToEmployees: "← Back to employees",

        // ── TOTP (Google Authenticator) — #92 ─────────────────
        emailLabel: "Email address",
        emailHint: "Used only for account recovery — no marketing emails.",
        emailRequired: "Please enter a valid email address",
        passwordTooShort: "Password is too short (min 4 characters)",
        registerSubmit: "Create account",
        registerLoading: "Creating...",
        registerTotpNote: "After creating your account, you will set up two-factor authentication via Google Authenticator.",
        loginSuccess: "Signed in",

        totpSetupTitle: "Set up 2FA",
        totpSetupSubtitle: "Scan the QR with Google Authenticator (or Authy / 1Password) to link this account.",
        totpSetupStep1: "Step 1 — Scan the QR code",
        totpSetupStep1Hint: "Open Authenticator → + → Scan a QR code.",
        totpSetupStep2: "Step 2 — Enter the first code",
        totpSetupStep2Hint: "Enter the 6-digit code displayed in your authenticator app.",
        totpSecretLabel: "Or enter manually:",
        totpActivateBtn: "Activate 2FA",
        totpEnabledToast: "Two-factor authentication enabled",
        totpEnabledBanner: "2FA is now active — save your backup codes before continuing.",
        totpBackupCodesTitle: "Backup recovery codes (6 codes)",
        totpBackupCodesSubtitle: "Each code works only once. Store them somewhere safe — they won't be shown again.",
        totpBackupCodesFootnote: "Each code is single-use. Do not share with anyone.",
        totpCopyAll: "Copy all",
        totpDownloadTxt: "Download (.txt)",
        totpAckSaved: "I have saved my backup codes somewhere safe.",
        totpFinishSetup: "Continue",
        copiedToast: "Copied",

        totpChallengeTitle: "Two-step verification",
        totpChallengeSubtitle: "Open Google Authenticator and enter your current 6-digit code.",
        totpBackupSubtitle: "Enter one of your recovery codes (single-use).",
        totpCodeLabel: "Verification code",
        totpCodeHint: "Codes rotate every 30 seconds automatically.",
        totpBackupLabel: "Recovery code",
        totpBackupHint: "Example: ABCD-EFGH",
        totpVerifyAndLogin: "Verify & sign in",
        totpUseBackupBtn: "Lost your device? Use a recovery code",
        totpUseCodeBtn: "← Back to authenticator code",
        totpBackToLogin: "Back to sign in",
        totpInvalidFormat: "Enter a 6-digit code",
        totpBackupRequired: "Enter your backup code",
        totpBackupUsedWarning: "Signed in with a backup code — consider regenerating new codes from Settings.",

        // ── Account email association in QR + recovery (#93) ─────
        totpAccountInAuth: "Account will appear in Authenticator as",
        locationRequired: "Please choose your country and city",
        recoverLink: "Forgot password?",
        recoverNowBtn: "Start account recovery now",
        recoverTitle: "Account recovery",
        recoverSubtitle: "Reset your password by verifying 2FA",
        recoverStep1Label: "Identify account",
        recoverStep2Label: "Verify with TOTP",
        recoverStep3Label: "New password",
        recoverStep1Hint: "Enter your company name and the registered email.",
        recoverStep2Hint: "Open Google Authenticator and enter your current 6-digit code.",
        recoverStep3Hint: "Choose a new password — you'll use it on your next sign-in.",
        recoverFieldsRequired: "Please enter both company name and email",
        recoverContinueBtn: "Continue",
        recoverVerifyBtn: "Verify code",
        recoverSavePasswordBtn: "Save password",
        recoverNewPasswordLabel: "New password",
        recoverPasswordChangedToast: "Password changed — you can sign in now",

        // ── In-Settings TOTP enrolment for whitelisted accounts (#95) ──
        settingsTotpTitle: "Enable two-factor authentication (TOTP)",
        settingsTotpSubtitle: "Add an extra security layer via Google Authenticator. Used for sensitive actions and account recovery.",
        settingsTotpStep1: "Confirm email",
        settingsTotpStep2: "Scan QR",
        settingsTotpStep3: "Backup codes",
        settingsTotpStep1Hint: "Re-enter the email registered with this account to confirm ownership.",
        settingsTotpStep2Hint: "Scan the QR with Google Authenticator, then enter the 6-digit code below.",
        settingsTotpVerifyEmailBtn: "Confirm email & continue",
        settingsTotpBackupTitle: "Save these backup codes (6 codes)",
    },
};

const LangContext = createContext(null);

export function LangProvider({ children }) {
    const [lang, setLang] = useState(() => {
        try {
            const v = localStorage.getItem(STORAGE_KEY);
            return v === "en" ? "en" : "ar";
        } catch {
            return "ar";
        }
    });

    // Sync <html dir/lang> globally so inputs and CSS logical props follow.
    useEffect(() => {
        const html = document.documentElement;
        html.setAttribute("dir", STRINGS[lang].dir);
        html.setAttribute("lang", lang);
    }, [lang]);

    const toggle = useCallback(() => {
        setLang((prev) => {
            const next = prev === "ar" ? "en" : "ar";
            try {
                localStorage.setItem(STORAGE_KEY, next);
            } catch {
                /* ignore */
            }
            return next;
        });
    }, []);

    const value = { lang, t: STRINGS[lang], toggle };
    return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
}

export function useLang() {
    const ctx = useContext(LangContext);
    if (!ctx) throw new Error("useLang must be used inside <LangProvider>");
    return ctx;
}
